// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".userInformation[data-v-a6942226]{background:transparent linear-gradient(90deg,#039,#00b4ff) 0 0 no-repeat padding-box;border-radius:10px;opacity:1}.flex-flow-col[data-v-a6942226]{flex-flow:column}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
